<template>
	<template v-if="languagesStore.isLoaded">
		<contact-us-modal v-if="currentSite.contactUs"/>
		<layout-header/>
		<main>
			<router-view/>
		</main>
		<layout-footer/>
	</template>
</template>

<script lang="ts">
import {defineComponent} from "vue";
import LayoutHeader from "../Components/Layout/LayoutHeader.vue";
import LayoutFooter from "../Components/Layout/LayoutFooter.vue";
import {useLanguagesStore} from "../Stores/LanguagesStore";
import {LayoutCssVariables} from "../Utils/LayoutCssVariables";
import {useSiteCheckStore} from "../Stores/SiteCheck/SiteCheck";
import ContactUsModal from "@/WebApp/Modals/ContactUsModal.vue";
import {SiteCheckInterface} from "@/WebApp/Stores/SiteCheck/Interfaces/SiteCheckInterface";

export default defineComponent({
	name: "App",
	components: {ContactUsModal, LayoutFooter, LayoutHeader},
	setup() {
		return {
			languagesStore: useLanguagesStore(),
			siteStore: useSiteCheckStore(),
		}
	},
	mounted() {
		this.siteStore.getSite();
		this.languagesStore.getTranslationList();
	},
	computed: {
		bgColor(): string {
			return `var(--${LayoutCssVariables.page.bgColor})`;
		},
		currentSite(): SiteCheckInterface {
			return this.siteStore.currentSite;
		}
	},
});
</script>

<style scoped>
main {
	background-color: v-bind(bgColor);
}
</style>
